import { emptyCellValidator } from './EmptyCellValidator';
import { previousRowConsistencyValidator } from './PreviousRowConsistencyValidator';
import { baseballLogicValidator } from './BaseballLogicValidator';
import { playerValidator } from './PlayerValidator';
import { playResultValidator } from './PlayResultValidator';
import { defensivePlayerValidator } from './DefensivePlayersValidator';

export const allValidators = [
  emptyCellValidator,
  previousRowConsistencyValidator,
  baseballLogicValidator,
  playerValidator,
  playResultValidator,
  defensivePlayerValidator,
];

export const basicValidators = [
  emptyCellValidator,
  previousRowConsistencyValidator,
  baseballLogicValidator,
  playerValidator,
  playResultValidator,
];
